import axios from "axios";
import store from "../../store";

const getAuthToken = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const dateNow = Date.now();
      let token = localStorage.getItem("a_t");

      if (!localStorage.getItem("expiresIn")) {
        localStorage.setItem("expiresIn", dateNow + 31536000);
      }
      const expiresIn = localStorage.getItem("expiresIn");


      if (dateNow >= expiresIn || !token) {
        const { data } = await axios.post("/oauth/token", {
          grant_type: "client_credentials",
          client_secret: process.env.VUE_APP_CLIENT_AP,
          client_id: Number(process.env.VUE_APP_CLIENT_ID),
        });

        const { access_token } = data;
        store.dispatch("auth/setToken", access_token);
        localStorage.setItem("a_t", access_token);
        localStorage.setItem("expiresIn", dateNow + 31536000);
        token = access_token;
      }

      resolve({
        access_token: token,
        token_type: "Bearer",
      });
    } catch (error) {
      reject(error);
    }
  });
};

const getUserGeo = () => {
  return new Promise((resolve, reject) => {
    let url = "https://ipapi.co/json/";
    axios
      .get(url)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const sendComment = (data) => {
  return new Promise((resolve, reject) => {
    let url = "/api/v1/createContact";
    axios
      .post(url, {
        ...data,
        proyect_id: Number(process.env.VUE_APP_PROYECT_ID),
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  getAuthToken,
  getUserGeo,
  sendComment,
};
